import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DataService } from "../data.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { dataType } from "../dataType";
import { ToastrManager } from "ng6-toastr-notifications";

@Component({
  selector: "app-update-user",
  templateUrl: "./update-user.component.html",
  styleUrls: ["./update-user.component.css"]
})
export class UpdateUserComponent implements OnInit {
  public username;
  public selectedFile;
  public pic;
  public userdata = new dataType();
  UserAttributes = {
    userAttribute: [],
    region: localStorage.getItem("region"),
    poolId : localStorage.getItem('poolId')
  };

  constructor(
    private router: Router,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private toastr: ToastrManager
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      console.log(params);
      this.username = params.userName;
    });
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
    }, 2000);
  }
  acceptedMimeTypes = [
    'image/gif',
    'image/jpeg',
    'image/png'
  ];
  
  @ViewChild('fileInput') fileInput: ElementRef;
  fileDataUri = '';
  errorMsg = '';
  
  previewFile() {
    const file = this.fileInput.nativeElement.files[0];
    if (file && this.validateFile(file)) {
  
      const reader = new FileReader();
      reader.readAsDataURL(this.fileInput.nativeElement.files[0]);
      reader.onload = () => {
        this.fileDataUri = JSON.stringify(reader.result);
      }
    } else {
      this.errorMsg = 'File must be jpg, png, or gif and cannot be exceed 500 KB in size'
    }
  }
  
  uploadFile(event: Event) {
    event.preventDefault();
  
    // get only the base64 file
    if (this.fileDataUri.length > 0) {
      const base64File = this.fileDataUri.split(',')[1];
      // TODO: send to server
      //console.log(base64File);
  
      this.dataService.uploadImage({"image":base64File,"bucket": "admin-panel-test"}).subscribe(
        res => {
          if(typeof res =='string'){
            res = JSON.parse(res)
          }
          console.log(res)
          this.pic = res.Data.Location;
          this.toastr.successToastr('Image Uploaded', 'Success!');

        }
      )
    }
  
  }
  
  validateFile(file) {
    return this.acceptedMimeTypes.includes(file.type) && file.size < 500000;
  }
  updateUserAttribute(): void {
    this.UserAttributes.userAttribute.push(
      { Name: "name", Value: this.userdata.fname },
      { Name: "email", Value: this.userdata.email },
      { Name: "phone_number", Value: this.userdata.phonenumber },
      {
        Name: "email_verified",
        Value: this.userdata.chkemail == true ? "true" : "false"
      },
      {
        Name: "phone_number_verified",
        Value: this.userdata.chkphonenumber == true ? "true" : "false"
      },
      { Name: "picture", Value: this.pic }
    );
    console.log(this.username);
    this.UserAttributes["username"] = this.username;

    console.log(this.UserAttributes);
    this.dataService
      .updateUserAttribute(this.UserAttributes)
      .subscribe((newData: any) => {
        if (typeof newData == "string") {
          newData = JSON.parse(newData);
        }
        console.log(typeof newData);
        if (newData.Status == "Error") {
          console.log(newData.Error.message);
          // alert(newData.Error.message);
          this.toastr.errorToastr(newData.Error.message,"oops!")
        } else if (newData.Status == "Success") {
          // alert("User Updated Successfully");
          this.toastr.successToastr("User Updated Successfully","Success!")
          this.router.navigate(["/users"]);
        }
      });
  }
}
